<template>
  <div class="mb-5">
    <h4 class="title-2 bold mb-3">
      {{ title }}<MetricInfoTooltip :content="latenessHelpText" />
    </h4>
    <div class="text-route mb-3">
      Rutas totales: {{ totalRoutes }} · Rutas tarde: {{ totalTardies }} · % rutas tarde: {{ percentageTardies }}%
    </div>
    <el-table
      :data="tardanzas"
      row-key="id"
      header-row-class-name="thead-desing"
      class="table-responsive desing"
    >
      <el-table-column label="Fecha" prop="date" min-width="100px" />
      <el-table-column label="Ruta (Codigo)" prop="name" min-width="139px">
        <template v-slot="{ row }"><strong>{{ row.name }}</strong></template>
      </el-table-column>
      <el-table-column label="Hora programada" prop="scheduledTime" min-width="150px" />
      <el-table-column label="Hora de entrega" prop="deliveredTime" min-width="150px" />
      <el-table-column label="Tardanza (min)" prop="totalTimeTardie" min-width="110px" />
      <el-table-column label="Status" prop="status" min-width="110px">
        <template v-slot="{ row }">
          <strong class="tag-level-desing" :class="{ red: row.status === 'Tarde', green: row.status === 'A tiempo' }">{{ row.status }}</strong>
        </template>
      </el-table-column>
      <el-table-column label="Penalidad" prop="penaltyAmount" min-width="120px">
        <template v-slot="{ row }"><strong class="penalty">{{ formatMoney(row.currency, row.penaltyAmount) }}</strong></template>
      </el-table-column>
    </el-table>
    <div class="d-flex justify-content-between flex-wrap mt-4">
      <p class="card-category">Mostrando {{ pagination.from }} a {{ pagination.to }} de {{ pagination.totalItems }} registros</p>
      <base-pagination
        v-if="pagination.totalItems > pagination.rowsPerPage"
        class="pagination-no-border"
        :value="pagination.page"
        :per-page="pagination.rowsPerPage"
        :total="pagination.totalItems"
        @input="loadPage"
      />
    </div>
  </div>
</template>

<script>
import { Table, TableColumn } from "element-ui";
import { mapActions, mapState } from "vuex";
import MetricInfoTooltip from "@/components/Levels/MetricInfoTooltip";
import { buildLatenessHelpText, formatLastPreviousFormulaDay, formatMoney } from "@/utils/dailyMenuLevelHelpTexts";

const FIRST_PAGE = 1;

export default {
  name: "LegacyLatenessSection",
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    MetricInfoTooltip
  },
  props: {
    initDate: { type: String, default: null },
    endDate: { type: String, default: null },
    changeDate: { type: String, default: null }
  },
  computed: {
    title() {
      return `Tardanza (cálculo anterior, hasta el ${formatLastPreviousFormulaDay(this.changeDate)})`;
    },
    latenessHelpText() {
      return buildLatenessHelpText(this.changeDate);
    },
    ...mapState("tardanza", ["tardanzas", "pagination", "totalRoutes", "totalTardies", "percentageTardies"])
  },
  watch: {
    initDate: "reload",
    endDate: "reload"
  },
  mounted() {
    this.reload();
  },
  methods: {
    formatMoney,
    ...mapActions("tardanza", ["GET_TARDANZAS"]),
    reload() {
      this.loadPage(FIRST_PAGE);
    },
    loadPage(page) {
      return this.GET_TARDANZAS({ page, init_date: this.initDate, end_date: this.endDate });
    }
  }
};
</script>
